import * as React from "react";
import { forwardRef, memo } from "react";
const SvgBs = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 6 3", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#00778B", d: "M0 0h6v3H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#FFC72C", d: "M0 1h6v1H0z" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0v3l2.59808-1.5z" }));
const ForwardRef = forwardRef(SvgBs);
const Memo = memo(ForwardRef);
export default Memo;
